var _rect, _g, _tspan, _tspan2, _path, _path2, _tspan3, _path3, _tspan4, _path4, _tspan5, _path5, _tspan6, _path6, _tspan7, _path7, _tspan8, _path8, _tspan9, _path9, _tspan10, _path10, _tspan11, _path11, _tspan12, _path12, _tspan13, _path13, _tspan14, _path14, _tspan15, _path15, _tspan16, _path16, _tspan17, _path17, _tspan18, _path18, _tspan19, _path19, _tspan20, _path20, _tspan21, _path21, _tspan22, _path22, _tspan23, _path23, _tspan24, _path24, _tspan25, _path25, _tspan26, _path26, _tspan27, _path27, _tspan28, _path28, _tspan29, _path29, _tspan30, _path30, _tspan31, _path31, _tspan32, _path32, _tspan33, _path33, _tspan34, _path34, _tspan35, _path35, _tspan36, _path36, _tspan37, _path37, _tspan38, _tspan39, _path38, _path39, _tspan40, _path40, _tspan41, _path41, _tspan42, _path42, _tspan43, _path43, _tspan44, _path44, _tspan45, _path45, _tspan46, _path46, _tspan47, _path47, _tspan48, _path48, _tspan49, _path49, _tspan50, _path50, _tspan51, _path51, _tspan52, _path52, _tspan53, _g2, _path53, _tspan54, _g3, _tspan55, _path54, _g4, _path55, _tspan56, _g5, _path56, _tspan57, _g6, _path57, _tspan58, _g7, _path58, _tspan59, _g8, _path59, _tspan60, _g9, _path60, _tspan61, _g10, _path61, _tspan62, _g11, _path62, _tspan63, _g12, _path63, _tspan64, _g13, _tspan65, _path64, _g14, _path65, _tspan66, _g15, _tspan67, _path66, _g16, _path67, _tspan68, _g17, _path68, _tspan69, _g18, _path69, _tspan70, _g19, _path70, _tspan71, _g20, _path71, _tspan72, _g21, _path72, _tspan73, _g22, _path73, _tspan74, _g23, _path74, _tspan75, _g24, _path75, _tspan76, _g25, _path76, _tspan77, _g26, _path77, _tspan78, _g27, _path78, _tspan79, _g28, _path79, _tspan80, _g29, _path80, _tspan81, _g30, _path81, _tspan82, _g31, _path82, _tspan83;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1906,
    height: 770,
    viewBox: "0 0 1906 770",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1906,
    height: 770,
    fill: "#F5F5F5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g_svg"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g_bkg"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1",
    width: 1906,
    height: 770,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g_main"
  }, /*#__PURE__*/React.createElement("g", {
    id: "gheader"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Global Giants by Market Capitalization",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 32,
    letterSpacing: "0em"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 664,
    y: 63.1364
  }, "Global Giants by Market Capitalization ")))), /*#__PURE__*/React.createElement("g", {
    id: "xAxisNameLabel"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Year of foundation",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 21,
    letterSpacing: "0em"
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 1662.07,
    y: 754.586
  }, "Year of  foundation"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_18"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Line",
    d: "M172.94 703.67V696.07H1650.1V703.67",
    stroke: "black",
    strokeWidth: 1.27
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M197.81 696.07V703.67",
    stroke: "black",
    strokeWidth: 1.27
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x38_40"
  }, /*#__PURE__*/React.createElement("text", {
    id: 1840,
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 17,
    letterSpacing: "0em"
  }, _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: 180.62,
    y: 728.682
  }, "1840"))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_20"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M239.33 696.07V703.67",
    stroke: "black",
    strokeWidth: 1.27
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x38_45"
  }, /*#__PURE__*/React.createElement("text", {
    id: 1845,
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 17,
    letterSpacing: "0em"
  }, _tspan4 || (_tspan4 = /*#__PURE__*/React.createElement("tspan", {
    x: 222.13,
    y: 728.682
  }, "1845"))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M280.81 696.07V703.67",
    stroke: "black",
    strokeWidth: 1.27
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x38_50"
  }, /*#__PURE__*/React.createElement("text", {
    id: 1850,
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 17,
    letterSpacing: "0em"
  }, _tspan5 || (_tspan5 = /*#__PURE__*/React.createElement("tspan", {
    x: 263.62,
    y: 728.682
  }, "1850"))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_22"
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M322.3 696.07V703.67",
    stroke: "black",
    strokeWidth: 1.27
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x38_55"
  }, /*#__PURE__*/React.createElement("text", {
    id: 1855,
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 17,
    letterSpacing: "0em"
  }, _tspan6 || (_tspan6 = /*#__PURE__*/React.createElement("tspan", {
    x: 305.74,
    y: 728.682
  }, "1855"))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_23"
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M363.79 696.07V703.67",
    stroke: "black",
    strokeWidth: 1.27
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x38_60"
  }, /*#__PURE__*/React.createElement("text", {
    id: 1860,
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 17,
    letterSpacing: "0em"
  }, _tspan7 || (_tspan7 = /*#__PURE__*/React.createElement("tspan", {
    x: 346.6,
    y: 728.682
  }, "1860"))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_24"
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M405.3 696.07V703.67",
    stroke: "black",
    strokeWidth: 1.27
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x38_65"
  }, /*#__PURE__*/React.createElement("text", {
    id: 1865,
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 17,
    letterSpacing: "0em"
  }, _tspan8 || (_tspan8 = /*#__PURE__*/React.createElement("tspan", {
    x: 388.11,
    y: 728.682
  }, "1865"))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25"
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M446.79 696.07V703.67",
    stroke: "black",
    strokeWidth: 1.27
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x38_70"
  }, /*#__PURE__*/React.createElement("text", {
    id: 1870,
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 17,
    letterSpacing: "0em"
  }, _tspan9 || (_tspan9 = /*#__PURE__*/React.createElement("tspan", {
    x: 430.23,
    y: 728.682
  }, "1870"))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26"
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M488.28 696.07V703.67",
    stroke: "black",
    strokeWidth: 1.27
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x38_75"
  }, /*#__PURE__*/React.createElement("text", {
    id: 1875,
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 17,
    letterSpacing: "0em"
  }, _tspan10 || (_tspan10 = /*#__PURE__*/React.createElement("tspan", {
    x: 471.72,
    y: 728.682
  }, "1875"))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_27"
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M529.77 696.07V703.67",
    stroke: "black",
    strokeWidth: 1.27
  })), /*#__PURE__*/React.createElement("g", {
    id: ":08"
  }, /*#__PURE__*/React.createElement("text", {
    id: 1880,
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 17,
    letterSpacing: "0em"
  }, _tspan11 || (_tspan11 = /*#__PURE__*/React.createElement("tspan", {
    x: 512.84,
    y: 728.682
  }, "1880"))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_28"
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M571.28 696.07V703.67",
    stroke: "black",
    strokeWidth: 1.27
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x38_85"
  }, /*#__PURE__*/React.createElement("text", {
    id: 1885,
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 17,
    letterSpacing: "0em"
  }, _tspan12 || (_tspan12 = /*#__PURE__*/React.createElement("tspan", {
    x: 554.09,
    y: 728.682
  }, "1885"))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_29"
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M612.77 696.07V703.67",
    stroke: "black",
    strokeWidth: 1.27
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x38_90"
  }, /*#__PURE__*/React.createElement("text", {
    id: 1890,
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 17,
    letterSpacing: "0em"
  }, _tspan13 || (_tspan13 = /*#__PURE__*/React.createElement("tspan", {
    x: 595.57,
    y: 728.682
  }, "1890"))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_30"
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M654.26 696.07V703.67",
    stroke: "black",
    strokeWidth: 1.27
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x38_95"
  }, /*#__PURE__*/React.createElement("text", {
    id: 1895,
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 17,
    letterSpacing: "0em"
  }, _tspan14 || (_tspan14 = /*#__PURE__*/React.createElement("tspan", {
    x: 637.06,
    y: 728.682
  }, "1895"))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_31"
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M695.75 696.07V703.67",
    stroke: "black",
    strokeWidth: 1.27
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x39_00"
  }, /*#__PURE__*/React.createElement("text", {
    id: 1900,
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 17,
    letterSpacing: "0em"
  }, _tspan15 || (_tspan15 = /*#__PURE__*/React.createElement("tspan", {
    x: 678.55,
    y: 728.682
  }, "1900"))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_32"
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M737.24 696.07V703.67",
    stroke: "black",
    strokeWidth: 1.27
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x39_05"
  }, /*#__PURE__*/React.createElement("text", {
    id: 1905,
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 17,
    letterSpacing: "0em"
  }, _tspan16 || (_tspan16 = /*#__PURE__*/React.createElement("tspan", {
    x: 720.04,
    y: 728.682
  }, "1905"))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_33"
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M778.72 696.07V703.67",
    stroke: "black",
    strokeWidth: 1.27
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x39_10"
  }, /*#__PURE__*/React.createElement("text", {
    id: 1910,
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 17,
    letterSpacing: "0em"
  }, _tspan17 || (_tspan17 = /*#__PURE__*/React.createElement("tspan", {
    x: 762.79,
    y: 728.682
  }, "1910"))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_34"
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M820.21 696.07V703.67",
    stroke: "black",
    strokeWidth: 1.27
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x39_15"
  }, /*#__PURE__*/React.createElement("text", {
    id: 1915,
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 17,
    letterSpacing: "0em"
  }, _tspan18 || (_tspan18 = /*#__PURE__*/React.createElement("tspan", {
    x: 804.28,
    y: 728.682
  }, "1915"))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_35"
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M861.7 696.07V703.67",
    stroke: "black",
    strokeWidth: 1.27
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x39_20"
  }, /*#__PURE__*/React.createElement("text", {
    id: 1920,
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 17,
    letterSpacing: "0em"
  }, _tspan19 || (_tspan19 = /*#__PURE__*/React.createElement("tspan", {
    x: 844.51,
    y: 728.682
  }, "1920"))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_36"
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M903.21 696.07V703.67",
    stroke: "black",
    strokeWidth: 1.27
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x39_25"
  }, /*#__PURE__*/React.createElement("text", {
    id: 1925,
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 17,
    letterSpacing: "0em"
  }, _tspan20 || (_tspan20 = /*#__PURE__*/React.createElement("tspan", {
    x: 886.02,
    y: 728.682
  }, "1925"))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_37"
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M944.7 696.07V703.67",
    stroke: "black",
    strokeWidth: 1.27
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x39_30"
  }, /*#__PURE__*/React.createElement("text", {
    id: 1930,
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 17,
    letterSpacing: "0em"
  }, _tspan21 || (_tspan21 = /*#__PURE__*/React.createElement("tspan", {
    x: 927.51,
    y: 728.682
  }, "1930"))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_38"
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M986.19 696.07V703.67",
    stroke: "black",
    strokeWidth: 1.27
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x39_35"
  }, /*#__PURE__*/React.createElement("text", {
    id: 1935,
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 17,
    letterSpacing: "0em"
  }, _tspan22 || (_tspan22 = /*#__PURE__*/React.createElement("tspan", {
    x: 968.99,
    y: 728.682
  }, "1935"))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39"
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M1027.68 696.07V703.67",
    stroke: "black",
    strokeWidth: 1.27
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x39_40"
  }, /*#__PURE__*/React.createElement("text", {
    id: 1940,
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 17,
    letterSpacing: "0em"
  }, _tspan23 || (_tspan23 = /*#__PURE__*/React.createElement("tspan", {
    x: 1010.48,
    y: 728.682
  }, "1940"))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_40"
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M1069.18 696.07V703.67",
    stroke: "black",
    strokeWidth: 1.27
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x39_45"
  }, /*#__PURE__*/React.createElement("text", {
    id: 1945,
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 17,
    letterSpacing: "0em"
  }, _tspan24 || (_tspan24 = /*#__PURE__*/React.createElement("tspan", {
    x: 1051.99,
    y: 728.682
  }, "1945"))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_41"
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M1110.68 696.07V703.67",
    stroke: "black",
    strokeWidth: 1.27
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x39_50"
  }, /*#__PURE__*/React.createElement("text", {
    id: 1950,
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 17,
    letterSpacing: "0em"
  }, _tspan25 || (_tspan25 = /*#__PURE__*/React.createElement("tspan", {
    x: 1093.48,
    y: 728.682
  }, "1950"))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_42"
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    d: "M1152.16 696.07V703.67",
    stroke: "black",
    strokeWidth: 1.27
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x39_55"
  }, /*#__PURE__*/React.createElement("text", {
    id: 1955,
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 17,
    letterSpacing: "0em"
  }, _tspan26 || (_tspan26 = /*#__PURE__*/React.createElement("tspan", {
    x: 1134.97,
    y: 728.682
  }, "1955"))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_43"
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    d: "M1193.66 696.07V703.67",
    stroke: "black",
    strokeWidth: 1.27
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x39_60"
  }, /*#__PURE__*/React.createElement("text", {
    id: 1960,
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 17,
    letterSpacing: "0em"
  }, _tspan27 || (_tspan27 = /*#__PURE__*/React.createElement("tspan", {
    x: 1176.46,
    y: 728.682
  }, "1960"))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_44"
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_45",
    d: "M1235.16 696.07V703.67",
    stroke: "black",
    strokeWidth: 1.27
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x39_65"
  }, /*#__PURE__*/React.createElement("text", {
    id: 1965,
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 17,
    letterSpacing: "0em"
  }, _tspan28 || (_tspan28 = /*#__PURE__*/React.createElement("tspan", {
    x: 1217.97,
    y: 728.682
  }, "1965"))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_45"
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_46",
    d: "M1276.66 696.07V703.67",
    stroke: "black",
    strokeWidth: 1.27
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x39_70"
  }, /*#__PURE__*/React.createElement("text", {
    id: 1970,
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 17,
    letterSpacing: "0em"
  }, _tspan29 || (_tspan29 = /*#__PURE__*/React.createElement("tspan", {
    x: 1260.1,
    y: 728.682
  }, "1970"))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_46"
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_47",
    d: "M1318.14 696.07V703.67",
    stroke: "black",
    strokeWidth: 1.27
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x39_75"
  }, /*#__PURE__*/React.createElement("text", {
    id: 1975,
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 17,
    letterSpacing: "0em"
  }, _tspan30 || (_tspan30 = /*#__PURE__*/React.createElement("tspan", {
    x: 1301.58,
    y: 728.682
  }, "1975"))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_47"
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_48",
    d: "M1359.63 696.07V703.67",
    stroke: "black",
    strokeWidth: 1.27
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x39_80"
  }, /*#__PURE__*/React.createElement("text", {
    id: 1980,
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 17,
    letterSpacing: "0em"
  }, _tspan31 || (_tspan31 = /*#__PURE__*/React.createElement("tspan", {
    x: 1342.44,
    y: 728.682
  }, "1980"))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48"
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_49",
    d: "M1401.14 696.07V703.67",
    stroke: "black",
    strokeWidth: 1.27
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x39_85"
  }, /*#__PURE__*/React.createElement("text", {
    id: 1985,
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 17,
    letterSpacing: "0em"
  }, _tspan32 || (_tspan32 = /*#__PURE__*/React.createElement("tspan", {
    x: 1383.95,
    y: 728.682
  }, "1985"))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_49"
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_50",
    d: "M1442.64 696.07V703.67",
    stroke: "black",
    strokeWidth: 1.27
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x39_90"
  }, /*#__PURE__*/React.createElement("text", {
    id: 1990,
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 17,
    letterSpacing: "0em"
  }, _tspan33 || (_tspan33 = /*#__PURE__*/React.createElement("tspan", {
    x: 1425.44,
    y: 728.682
  }, "1990"))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_50"
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_51",
    d: "M1484.12 696.07V703.67",
    stroke: "black",
    strokeWidth: 1.27
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x39_95"
  }, /*#__PURE__*/React.createElement("text", {
    id: 1995,
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 17,
    letterSpacing: "0em"
  }, _tspan34 || (_tspan34 = /*#__PURE__*/React.createElement("tspan", {
    x: 1466.93,
    y: 728.682
  }, "1995"))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_51"
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_52",
    d: "M1525.61 696.07V703.67",
    stroke: "black",
    strokeWidth: 1.27
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x30_00"
  }, /*#__PURE__*/React.createElement("text", {
    id: 2000,
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 17,
    letterSpacing: "0em"
  }, _tspan35 || (_tspan35 = /*#__PURE__*/React.createElement("tspan", {
    x: 1507.79,
    y: 728.682
  }, "2000"))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_52"
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_53",
    d: "M1567.12 696.07V703.67",
    stroke: "black",
    strokeWidth: 1.27
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x30_05"
  }, /*#__PURE__*/React.createElement("text", {
    id: 2005,
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 17,
    letterSpacing: "0em"
  }, _tspan36 || (_tspan36 = /*#__PURE__*/React.createElement("tspan", {
    x: 1549.29,
    y: 728.682
  }, "2005"))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_53"
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_54",
    d: "M1608.6 696.07V703.67",
    stroke: "black",
    strokeWidth: 1.27
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x30_10"
  }, /*#__PURE__*/React.createElement("text", {
    id: 2010,
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 17,
    letterSpacing: "0em"
  }, _tspan37 || (_tspan37 = /*#__PURE__*/React.createElement("tspan", {
    x: 1591.41,
    y: 728.682
  }, "2010"))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_54"
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_55",
    d: "M1650.1 696.07V703.67",
    stroke: "black",
    strokeWidth: 1.27
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x30_15"
  }, /*#__PURE__*/React.createElement("text", {
    id: 2015,
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 17,
    letterSpacing: "0em"
  }, _tspan38 || (_tspan38 = /*#__PURE__*/React.createElement("tspan", {
    x: 1632.9,
    y: 728.682
  }, "2015"))))))), /*#__PURE__*/React.createElement("g", {
    id: "yAxisNameLabel"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Market Capitalization in USD Trillion",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 21,
    letterSpacing: "0em"
  }, _tspan39 || (_tspan39 = /*#__PURE__*/React.createElement("tspan", {
    x: 92.62,
    y: 84.1564
  }, "Market Capitalization in USD Trillion"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Line_2",
    d: "M159.01 689.74H166.61V118.86H159.01",
    stroke: "black",
    strokeWidth: 1.27
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M166.6 689.74H159",
    stroke: "black",
    strokeWidth: 1.27
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x2E_11"
  }, /*#__PURE__*/React.createElement("text", {
    id: 0.11,
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 17,
    letterSpacing: "0em"
  }, _tspan40 || (_tspan40 = /*#__PURE__*/React.createElement("tspan", {
    x: 115.42,
    y: 695.022
  }, "0.11"))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M166.6 645.83H159",
    stroke: "black",
    strokeWidth: 1.27
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x2E_14"
  }, /*#__PURE__*/React.createElement("text", {
    id: 0.14,
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 17,
    letterSpacing: "0em"
  }, _tspan41 || (_tspan41 = /*#__PURE__*/React.createElement("tspan", {
    x: 114.48,
    y: 651.102
  }, "0.14"))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M166.6 601.91H159",
    stroke: "black",
    strokeWidth: 1.27
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x2E_18"
  }, /*#__PURE__*/React.createElement("text", {
    id: 0.18,
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 17,
    letterSpacing: "0em"
  }, _tspan42 || (_tspan42 = /*#__PURE__*/React.createElement("tspan", {
    x: 114.48,
    y: 607.192
  }, "0.18"))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M166.6 558H159",
    stroke: "black",
    strokeWidth: 1.27
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x2E_24"
  }, /*#__PURE__*/React.createElement("text", {
    id: 0.24,
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 17,
    letterSpacing: "0em"
  }, _tspan43 || (_tspan43 = /*#__PURE__*/React.createElement("tspan", {
    x: 114.48,
    y: 563.272
  }, "0.24"))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M166.6 514.09H159",
    stroke: "black",
    strokeWidth: 1.27
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x2E_31"
  }, /*#__PURE__*/React.createElement("text", {
    id: 0.31,
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 17,
    letterSpacing: "0em"
  }, _tspan44 || (_tspan44 = /*#__PURE__*/React.createElement("tspan", {
    x: 114.48,
    y: 519.362
  }, "0.31"))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M166.6 470.17H159",
    stroke: "black",
    strokeWidth: 1.27
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x2E_39"
  }, /*#__PURE__*/React.createElement("text", {
    id: 0.39,
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 17,
    letterSpacing: "0em"
  }, _tspan45 || (_tspan45 = /*#__PURE__*/React.createElement("tspan", {
    x: 114.48,
    y: 475.442
  }, "0.39"))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M166.6 426.26H159",
    stroke: "black",
    strokeWidth: 1.27
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x2E_51"
  }, /*#__PURE__*/React.createElement("text", {
    id: 0.51,
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 17,
    letterSpacing: "0em"
  }, _tspan46 || (_tspan46 = /*#__PURE__*/React.createElement("tspan", {
    x: 114.48,
    y: 431.532
  }, "0.51"))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M166.6 382.34H159",
    stroke: "black",
    strokeWidth: 1.27
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x2E_66"
  }, /*#__PURE__*/React.createElement("text", {
    id: 0.66,
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 17,
    letterSpacing: "0em"
  }, _tspan47 || (_tspan47 = /*#__PURE__*/React.createElement("tspan", {
    x: 114.48,
    y: 387.622
  }, "0.66"))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M166.6 338.43H159",
    stroke: "black",
    strokeWidth: 1.27
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x2E_85"
  }, /*#__PURE__*/React.createElement("text", {
    id: 0.85,
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 17,
    letterSpacing: "0em"
  }, _tspan48 || (_tspan48 = /*#__PURE__*/React.createElement("tspan", {
    x: 114.48,
    y: 343.702
  }, "0.85"))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M166.6 294.52H159",
    stroke: "black",
    strokeWidth: 1.27
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x2E_10"
  }, /*#__PURE__*/React.createElement("text", {
    id: 1.1,
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 17,
    letterSpacing: "0em"
  }, _tspan49 || (_tspan49 = /*#__PURE__*/React.createElement("tspan", {
    x: 114.48,
    y: 299.792
  }, "1.10"))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14"
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M166.6 250.6H159",
    stroke: "black",
    strokeWidth: 1.27
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x2E_43"
  }, /*#__PURE__*/React.createElement("text", {
    id: 1.43,
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 17,
    letterSpacing: "0em"
  }, _tspan50 || (_tspan50 = /*#__PURE__*/React.createElement("tspan", {
    x: 114.48,
    y: 255.872
  }, "1.43"))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15"
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M166.6 206.69H159",
    stroke: "black",
    strokeWidth: 1.27
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x2E_84"
  }, /*#__PURE__*/React.createElement("text", {
    id: 1.84,
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 17,
    letterSpacing: "0em"
  }, _tspan51 || (_tspan51 = /*#__PURE__*/React.createElement("tspan", {
    x: 114.48,
    y: 211.962
  }, "1.84"))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16"
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M166.6 162.77H159",
    stroke: "black",
    strokeWidth: 1.27
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x2E_39_2"
  }, /*#__PURE__*/React.createElement("text", {
    id: 2.39,
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 17,
    letterSpacing: "0em"
  }, _tspan52 || (_tspan52 = /*#__PURE__*/React.createElement("tspan", {
    x: 114.48,
    y: 168.052
  }, "2.39"))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_17"
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M166.6 118.86H159",
    stroke: "black",
    strokeWidth: 1.27
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x2E_09"
  }, /*#__PURE__*/React.createElement("text", {
    id: 3.09,
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 17,
    letterSpacing: "0em"
  }, _tspan53 || (_tspan53 = /*#__PURE__*/React.createElement("tspan", {
    x: 114.48,
    y: 124.132
  }, "3.09"))))))), /*#__PURE__*/React.createElement("g", {
    id: "Reliance_Industries"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "BubbleGroup"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.7,
    d: "M1177.07 573.77C1185.35 573.77 1192.07 567.054 1192.07 558.77C1192.07 550.486 1185.35 543.77 1177.07 543.77C1168.79 543.77 1162.07 550.486 1162.07 558.77C1162.07 567.054 1168.79 573.77 1177.07 573.77Z",
    fill: "#FFBBBB",
    stroke: "#333333",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M1177.07 564.46C1180.11 564.46 1182.57 561.998 1182.57 558.96C1182.57 555.922 1180.11 553.46 1177.07 553.46C1174.03 553.46 1171.57 555.922 1171.57 558.96C1171.57 561.998 1174.03 564.46 1177.07 564.46Z",
    fill: "#353535"
  }))), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "Line_3",
    d: "M1147.6 642.01V598.78H1177.07V578.77C1166.02 578.77 1157.07 569.82 1157.07 558.77C1157.07 547.72 1166.02 538.77 1177.07 538.77",
    stroke: "#8C8C8C",
    strokeWidth: 1.02,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("text", {
    id: "Reliance Industries",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 16,
    letterSpacing: "0em"
  }, _tspan54 || (_tspan54 = /*#__PURE__*/React.createElement("tspan", {
    x: 1081.58,
    y: 659.748
  }, "Reliance Industries")))), /*#__PURE__*/React.createElement("g", {
    id: "Coca_Cola"
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "BubbleGroup_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    opacity: 0.7,
    d: "M580.72 557.42C589.28 557.42 596.22 550.48 596.22 541.92C596.22 533.36 589.28 526.42 580.72 526.42C572.16 526.42 565.22 533.36 565.22 541.92C565.22 550.48 572.16 557.42 580.72 557.42Z",
    fill: "#FFBBBB",
    stroke: "#333333",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M580.72 547.62C583.758 547.62 586.22 545.158 586.22 542.12C586.22 539.082 583.758 536.62 580.72 536.62C577.682 536.62 575.22 539.082 575.22 542.12C575.22 545.158 577.682 547.62 580.72 547.62Z",
    fill: "#353535"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "Coca Cola",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 16,
    letterSpacing: "0em"
  }, _tspan55 || (_tspan55 = /*#__PURE__*/React.createElement("tspan", {
    x: 444.47,
    y: 494.938
  }, "Coca Cola"))), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "Line_4",
    d: "M512.84 491.4H527.54V541.92H560.22C560.22 530.6 569.4 521.42 580.72 521.42",
    stroke: "#8C8C8C",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "AbbVie"
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "BubbleGroup_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    opacity: 0.7,
    d: "M1625.19 524.09C1634.03 524.09 1641.19 516.927 1641.19 508.09C1641.19 499.253 1634.03 492.09 1625.19 492.09C1616.35 492.09 1609.19 499.253 1609.19 508.09C1609.19 516.927 1616.35 524.09 1625.19 524.09Z",
    fill: "#FFBBBB",
    stroke: "#333333",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_56",
    d: "M1625.19 513.79C1628.23 513.79 1630.69 511.328 1630.69 508.29C1630.69 505.252 1628.23 502.79 1625.19 502.79C1622.15 502.79 1619.69 505.252 1619.69 508.29C1619.69 511.328 1622.15 513.79 1625.19 513.79Z",
    fill: "#353535"
  }))), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "Line_5",
    d: "M1646.19 508.09C1646.19 519.69 1636.79 529.09 1625.19 529.09V566.98H1662.07V576.07",
    stroke: "#8C8C8C",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("text", {
    id: "AbbVie_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 16,
    letterSpacing: "0em"
  }, _tspan56 || (_tspan56 = /*#__PURE__*/React.createElement("tspan", {
    x: 1650.62,
    y: 595.368
  }, "AbbVie")))), /*#__PURE__*/React.createElement("g", {
    id: "Costco"
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "BubbleGroup_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_57",
    opacity: 0.7,
    d: "M1384.53 518.26C1393.64 518.26 1401.03 510.873 1401.03 501.76C1401.03 492.647 1393.64 485.26 1384.53 485.26C1375.42 485.26 1368.03 492.647 1368.03 501.76C1368.03 510.873 1375.42 518.26 1384.53 518.26Z",
    fill: "#FFBBBB",
    stroke: "#333333",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_58",
    d: "M1384.53 507.47C1387.57 507.47 1390.03 505.008 1390.03 501.97C1390.03 498.932 1387.57 496.47 1384.53 496.47C1381.49 496.47 1379.03 498.932 1379.03 501.97C1379.03 505.008 1381.49 507.47 1384.53 507.47Z",
    fill: "#353535"
  }))), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "Line_6",
    d: "M1363.03 501.76C1363.03 513.63 1372.66 523.26 1384.53 523.26V594.53H1363.86V620.97",
    stroke: "#8C8C8C",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("text", {
    id: "Costco_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 16,
    letterSpacing: "0em"
  }, _tspan57 || (_tspan57 = /*#__PURE__*/React.createElement("tspan", {
    x: 1335.98,
    y: 634.748
  }, "Costco")))), /*#__PURE__*/React.createElement("g", {
    id: "Procter__Gamble"
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "BubbleGroup_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_59",
    opacity: 0.7,
    d: "M172.94 493.4C182.329 493.4 189.94 485.789 189.94 476.4C189.94 467.011 182.329 459.4 172.94 459.4C163.551 459.4 155.94 467.011 155.94 476.4C155.94 485.789 163.551 493.4 172.94 493.4Z",
    fill: "#FFBBBB",
    stroke: "#333333",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_60",
    d: "M172.94 482.11C175.978 482.11 178.44 479.648 178.44 476.61C178.44 473.572 175.978 471.11 172.94 471.11C169.902 471.11 167.44 473.572 167.44 476.61C167.44 479.648 169.902 482.11 172.94 482.11Z",
    fill: "#353535"
  }))), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "Line_7",
    d: "M194.94 476.4C194.94 488.55 185.09 498.4 172.94 498.4V525.15H195.47V550.17",
    stroke: "#8C8C8C",
    strokeWidth: 1.38,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("text", {
    id: "textSpecial",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 16,
    letterSpacing: "0em"
  }, _tspan58 || (_tspan58 = /*#__PURE__*/React.createElement("tspan", {
    x: 187.66,
    y: 565.278
  }, "Procter &#38; Gamble")))), /*#__PURE__*/React.createElement("g", {
    id: "Home_Depot"
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "BubbleGroup_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_61",
    opacity: 0.7,
    d: "M1343.05 490.15C1352.72 490.15 1360.55 482.315 1360.55 472.65C1360.55 462.985 1352.72 455.15 1343.05 455.15C1333.39 455.15 1325.55 462.985 1325.55 472.65C1325.55 482.315 1333.39 490.15 1343.05 490.15Z",
    fill: "#FFBBBB",
    stroke: "#333333",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_62",
    d: "M1343.05 478.37C1346.09 478.37 1348.55 475.908 1348.55 472.87C1348.55 469.832 1346.09 467.37 1343.05 467.37C1340.01 467.37 1337.55 469.832 1337.55 472.87C1337.55 475.908 1340.01 478.37 1343.05 478.37Z",
    fill: "#353535"
  }))), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "Line_8",
    d: "M1320.55 472.65C1320.55 485.08 1330.62 495.15 1343.05 495.15V544.81H1322.51V571.34",
    stroke: "#8C8C8C",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("text", {
    id: "Home Depot",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 16,
    letterSpacing: "0em"
  }, _tspan59 || (_tspan59 = /*#__PURE__*/React.createElement("tspan", {
    x: 1270.61,
    y: 585.758
  }, "Home Depot")))), /*#__PURE__*/React.createElement("g", {
    id: "ASML"
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_63",
    opacity: 0.7,
    d: "M1392.82 490.01C1402.76 490.01 1410.82 481.951 1410.82 472.01C1410.82 462.069 1402.76 454.01 1392.82 454.01C1382.88 454.01 1374.82 462.069 1374.82 472.01C1374.82 481.951 1382.88 490.01 1392.82 490.01Z",
    fill: "#FFBBBB",
    stroke: "#333333",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_64",
    d: "M1392.82 477.74C1395.86 477.74 1398.32 475.278 1398.32 472.24C1398.32 469.202 1395.86 466.74 1392.82 466.74C1389.78 466.74 1387.32 469.202 1387.32 472.24C1387.32 475.278 1389.78 477.74 1392.82 477.74Z",
    fill: "#353535"
  }))), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "Line_9",
    d: "M1369.82 472.01C1369.82 459.31 1380.12 449.01 1392.82 449.01V427.2H1380.06V419.93",
    stroke: "#8C8C8C",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("text", {
    id: "ASML_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 16,
    letterSpacing: "0em"
  }, _tspan60 || (_tspan60 = /*#__PURE__*/React.createElement("tspan", {
    x: 1357.04,
    y: 411.448
  }, "ASML")))), /*#__PURE__*/React.createElement("g", {
    id: "Exxon_Mobil"
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "BubbleGroup_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_65",
    opacity: 0.7,
    d: "M1517.32 476.81C1527.54 476.81 1535.82 468.527 1535.82 458.31C1535.82 448.093 1527.54 439.81 1517.32 439.81C1507.1 439.81 1498.82 448.093 1498.82 458.31C1498.82 468.527 1507.1 476.81 1517.32 476.81Z",
    fill: "#FFBBBB",
    stroke: "#333333",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_66",
    d: "M1517.32 464.05C1520.36 464.05 1522.82 461.588 1522.82 458.55C1522.82 455.512 1520.36 453.05 1517.32 453.05C1514.28 453.05 1511.82 455.512 1511.82 458.55C1511.82 461.588 1514.28 464.05 1517.32 464.05Z",
    fill: "#353535"
  }))), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "Line_10",
    d: "M1540.82 458.31C1540.82 471.29 1530.3 481.81 1517.32 481.81V571.33H1574.55V611.18",
    stroke: "#8C8C8C",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("text", {
    id: "Exxon Mobil",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 16,
    letterSpacing: "0em"
  }, _tspan61 || (_tspan61 = /*#__PURE__*/React.createElement("tspan", {
    x: 1540.08,
    y: 628.508
  }, "Exxon Mobil")))), /*#__PURE__*/React.createElement("g", {
    id: "Mastercard"
  }, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "BubbleGroup_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_67",
    opacity: 0.7,
    d: "M1243.46 468.8C1253.95 468.8 1262.46 460.293 1262.46 449.8C1262.46 439.307 1253.95 430.8 1243.46 430.8C1232.97 430.8 1224.46 439.307 1224.46 449.8C1224.46 460.293 1232.97 468.8 1243.46 468.8Z",
    fill: "#FFBBBB",
    stroke: "#333333",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_68",
    d: "M1243.46 455.54C1246.5 455.54 1248.96 453.078 1248.96 450.04C1248.96 447.002 1246.5 444.54 1243.46 444.54C1240.42 444.54 1237.96 447.002 1237.96 450.04C1237.96 453.078 1240.42 455.54 1243.46 455.54Z",
    fill: "#353535"
  }))), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    id: "Line_11",
    d: "M1267.46 449.8C1267.46 463.05 1256.71 473.8 1243.46 473.8V492.08H1260.1V523.09",
    stroke: "#8C8C8C",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("text", {
    id: "Mastercard_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 16,
    letterSpacing: "0em"
  }, _tspan62 || (_tspan62 = /*#__PURE__*/React.createElement("tspan", {
    x: 1213.21,
    y: 536.978
  }, "Mastercard")))), /*#__PURE__*/React.createElement("g", {
    id: "United_Health_Group"
  }, _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "BubbleGroup_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_69",
    opacity: 0.7,
    d: "M1334.75 466.2C1345.52 466.2 1354.25 457.47 1354.25 446.7C1354.25 435.93 1345.52 427.2 1334.75 427.2C1323.98 427.2 1315.25 435.93 1315.25 446.7C1315.25 457.47 1323.98 466.2 1334.75 466.2Z",
    fill: "#FFBBBB",
    stroke: "#333333",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_70",
    d: "M1334.75 452.44C1337.79 452.44 1340.25 449.978 1340.25 446.94C1340.25 443.902 1337.79 441.44 1334.75 441.44C1331.71 441.44 1329.25 443.902 1329.25 446.94C1329.25 449.978 1331.71 452.44 1334.75 452.44Z",
    fill: "#353535"
  }))), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    id: "Line_12",
    d: "M1310.25 446.7C1310.25 433.17 1321.22 422.2 1334.75 422.2V397.21H1316.3V372.77",
    stroke: "#8C8C8C",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("text", {
    id: "United Health Group",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 16,
    letterSpacing: "0em"
  }, _tspan63 || (_tspan63 = /*#__PURE__*/React.createElement("tspan", {
    x: 1234.45,
    y: 362.888
  }, "United Health Group")))), /*#__PURE__*/React.createElement("g", {
    id: "LVMH"
  }, _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "BubbleGroup_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_71",
    opacity: 0.7,
    d: "M1417.73 463.52C1428.78 463.52 1437.73 454.566 1437.73 443.52C1437.73 432.474 1428.78 423.52 1417.73 423.52C1406.68 423.52 1397.73 432.474 1397.73 443.52C1397.73 454.566 1406.68 463.52 1417.73 463.52Z",
    fill: "#FFBBBB",
    stroke: "#333333",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_72",
    d: "M1417.73 449.27C1420.77 449.27 1423.23 446.808 1423.23 443.77C1423.23 440.732 1420.77 438.27 1417.73 438.27C1414.69 438.27 1412.23 440.732 1412.23 443.77C1412.23 446.808 1414.69 449.27 1417.73 449.27Z",
    fill: "#353535"
  }))), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    id: "Line_13",
    d: "M1442.73 443.52C1442.73 457.33 1431.54 468.52 1417.73 468.52V478.62H1467.53V519.92",
    stroke: "#8C8C8C",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("text", {
    id: "LVMH_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 16,
    letterSpacing: "0em"
  }, _tspan64 || (_tspan64 = /*#__PURE__*/React.createElement("tspan", {
    x: 1461.72,
    y: 536.438
  }, "LVMH")))), /*#__PURE__*/React.createElement("g", {
    id: "Walmart"
  }, _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "BubbleGroup_11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_73",
    opacity: 0.7,
    d: "M1210.27 459.67C1221.59 459.67 1230.77 450.492 1230.77 439.17C1230.77 427.848 1221.59 418.67 1210.27 418.67C1198.95 418.67 1189.77 427.848 1189.77 439.17C1189.77 450.492 1198.95 459.67 1210.27 459.67Z",
    fill: "#FFBBBB",
    stroke: "#333333",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_74",
    d: "M1210.27 444.93C1213.31 444.93 1215.77 442.468 1215.77 439.43C1215.77 436.392 1213.31 433.93 1210.27 433.93C1207.23 433.93 1204.77 436.392 1204.77 439.43C1204.77 442.468 1207.23 444.93 1210.27 444.93Z",
    fill: "#353535"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "Walmart_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 16,
    letterSpacing: "0em"
  }, _tspan65 || (_tspan65 = /*#__PURE__*/React.createElement("tspan", {
    x: 1116.2,
    y: 519.608
  }, "Walmart"))), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    id: "Line_14",
    d: "M1151.42 503.35V479.62H1210.27V464.67C1196.19 464.67 1184.77 453.25 1184.77 439.17",
    stroke: "#8C8C8C",
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Novo_Nordisk"
  }, _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "BubbleGroup_12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_75",
    opacity: 0.7,
    d: "M1177.07 434.11C1188.67 434.11 1198.07 424.708 1198.07 413.11C1198.07 401.512 1188.67 392.11 1177.07 392.11C1165.47 392.11 1156.07 401.512 1156.07 413.11C1156.07 424.708 1165.47 434.11 1177.07 434.11Z",
    fill: "#FFBBBB",
    stroke: "#333333",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_76",
    d: "M1177.07 418.87C1180.11 418.87 1182.57 416.408 1182.57 413.37C1182.57 410.332 1180.11 407.87 1177.07 407.87C1174.03 407.87 1171.57 410.332 1171.57 413.37C1171.57 416.408 1174.03 418.87 1177.07 418.87Z",
    fill: "#353535"
  }))), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    id: "Line_15",
    d: "M1177.07 439.11C1162.71 439.11 1151.07 427.47 1151.07 413.11H1122.1V398.48",
    stroke: "#8C8C8C",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("text", {
    id: "Novo Nordisk",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 16,
    letterSpacing: "0em"
  }, _tspan66 || (_tspan66 = /*#__PURE__*/React.createElement("tspan", {
    x: 1042.52,
    y: 390.688
  }, "Novo Nordisk")))), /*#__PURE__*/React.createElement("g", {
    id: "Visa"
  }, _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "BubbleGroup_13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_77",
    opacity: 0.7,
    d: "M1177.07 429.2C1188.94 429.2 1198.57 419.574 1198.57 407.7C1198.57 395.826 1188.94 386.2 1177.07 386.2C1165.2 386.2 1155.57 395.826 1155.57 407.7C1155.57 419.574 1165.2 429.2 1177.07 429.2Z",
    fill: "#FFBBBB",
    stroke: "#333333",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_78",
    d: "M1177.07 413.47C1180.11 413.47 1182.57 411.008 1182.57 407.97C1182.57 404.932 1180.11 402.47 1177.07 402.47C1174.03 402.47 1171.57 404.932 1171.57 407.97C1171.57 411.008 1174.03 413.47 1177.07 413.47Z",
    fill: "#353535"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "Visa_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 16,
    letterSpacing: "0em"
  }, _tspan67 || (_tspan67 = /*#__PURE__*/React.createElement("tspan", {
    x: 1120.81,
    y: 342.338
  }, "Visa"))), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    id: "Line_16",
    d: "M1152.56 339H1177.07V381.21C1191.71 381.21 1203.57 393.07 1203.57 407.71",
    stroke: "#8C8C8C",
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Bank_Of_China"
  }, _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_79",
    opacity: 0.7,
    d: "M795.31 644.58C807.46 644.58 817.31 634.73 817.31 622.58C817.31 610.43 807.46 600.58 795.31 600.58C783.16 600.58 773.31 610.43 773.31 622.58C773.31 634.73 783.16 644.58 795.31 644.58Z",
    fill: "#FFBBBB",
    stroke: "#333333",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_80",
    d: "M795.31 628.36C798.348 628.36 800.81 625.898 800.81 622.86C800.81 619.822 798.348 617.36 795.31 617.36C792.272 617.36 789.81 619.822 789.81 622.86C789.81 625.898 792.272 628.36 795.31 628.36Z",
    fill: "#353535"
  }))), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    id: "Line_17",
    d: "M795.31 649.58C780.4 649.58 768.31 637.49 768.31 622.58H766.39C758.81 622.58 753.73 622.58 746.16 622.58V648.59H687.44",
    stroke: "#8C8C8C",
    strokeWidth: 1.02,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Bank Of China",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 16,
    letterSpacing: "0em"
  }, _tspan68 || (_tspan68 = /*#__PURE__*/React.createElement("tspan", {
    x: 586.08,
    y: 650.428
  }, "Bank Of China")))), /*#__PURE__*/React.createElement("g", {
    id: "Samsung_Electronics"
  }, _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "BubbleGroup_14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_81",
    opacity: 0.7,
    d: "M1011.09 507.5C1023.52 507.5 1033.59 497.426 1033.59 485C1033.59 472.574 1023.52 462.5 1011.09 462.5C998.664 462.5 988.59 472.574 988.59 485C988.59 497.426 998.664 507.5 1011.09 507.5Z",
    fill: "#FFBBBB",
    stroke: "#333333",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_82",
    d: "M1011.09 490.78C1014.13 490.78 1016.59 488.318 1016.59 485.28C1016.59 482.242 1014.13 479.78 1011.09 479.78C1008.05 479.78 1005.59 482.242 1005.59 485.28C1005.59 488.318 1008.05 490.78 1011.09 490.78Z",
    fill: "#353535"
  }))), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    id: "Line_18",
    d: "M930.02 429.74V485H983.59C983.59 469.81 995.9 457.5 1011.09 457.5",
    stroke: "#8C8C8C",
    strokeWidth: 0.98,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("text", {
    id: "Samsung Electronics",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 16,
    letterSpacing: "0em"
  }, _tspan69 || (_tspan69 = /*#__PURE__*/React.createElement("tspan", {
    x: 844.63,
    y: 419.498
  }, "Samsung Electronics")))), /*#__PURE__*/React.createElement("g", {
    id: "Toyota_Motor"
  }, _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "BubbleGroup_15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_83",
    opacity: 0.7,
    d: "M1409.44 531.09C1422.14 531.09 1432.44 520.793 1432.44 508.09C1432.44 495.387 1422.14 485.09 1409.44 485.09C1396.74 485.09 1386.44 495.387 1386.44 508.09C1386.44 520.793 1396.74 531.09 1409.44 531.09Z",
    fill: "#FFBBBB",
    stroke: "#333333",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_84",
    d: "M1409.44 513.88C1412.48 513.88 1414.94 511.418 1414.94 508.38C1414.94 505.342 1412.48 502.88 1409.44 502.88C1406.4 502.88 1403.94 505.342 1403.94 508.38C1403.94 511.418 1406.4 513.88 1409.44 513.88Z",
    fill: "#353535"
  }))), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    id: "Line_19",
    d: "M1437.44 508.09C1437.44 523.55 1424.9 536.09 1409.44 536.09V572.59H1451.02V590.09",
    stroke: "#8C8C8C",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("text", {
    id: "Toyota Motor",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 16,
    letterSpacing: "0em"
  }, _tspan70 || (_tspan70 = /*#__PURE__*/React.createElement("tspan", {
    x: 1427.44,
    y: 605.218
  }, "Toyota Motor")))), /*#__PURE__*/React.createElement("g", {
    id: "Shell"
  }, _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "BubbleGroup_16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_85",
    opacity: 0.7,
    d: "M788.98 600.06C801.959 600.06 812.48 589.539 812.48 576.56C812.48 563.581 801.959 553.06 788.98 553.06C776.001 553.06 765.48 563.581 765.48 576.56C765.48 589.539 776.001 600.06 788.98 600.06Z",
    fill: "#FFBBBB",
    stroke: "#333333",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_86",
    d: "M788.98 582.36C792.018 582.36 794.48 579.898 794.48 576.86C794.48 573.822 792.018 571.36 788.98 571.36C785.942 571.36 783.48 573.822 783.48 576.86C783.48 579.898 785.942 582.36 788.98 582.36Z",
    fill: "#353535"
  }))), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    id: "Line_20",
    d: "M788.98 548.06C804.72 548.06 817.48 560.82 817.48 576.56H848.42V530.91",
    stroke: "#8C8C8C",
    strokeWidth: 0.98,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Shell_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 16,
    letterSpacing: "0em"
  }, _tspan71 || (_tspan71 = /*#__PURE__*/React.createElement("tspan", {
    x: 840.86,
    y: 523.028
  }, "Shell")))), /*#__PURE__*/React.createElement("g", {
    id: "HSBC_Holdings_plc"
  }, _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "BubbleGroup_17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_87",
    opacity: 0.7,
    d: "M405.3 713.74C418.555 713.74 429.3 702.995 429.3 689.74C429.3 676.485 418.555 665.74 405.3 665.74C392.045 665.74 381.3 676.485 381.3 689.74C381.3 702.995 392.045 713.74 405.3 713.74Z",
    fill: "#FFBBBB",
    stroke: "#333333",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_88",
    d: "M405.3 695.54C408.338 695.54 410.8 693.078 410.8 690.04C410.8 687.002 408.338 684.54 405.3 684.54C402.262 684.54 399.8 687.002 399.8 690.04C399.8 693.078 402.262 695.54 405.3 695.54Z",
    fill: "#353535"
  }))), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    id: "Line_21",
    d: "M405.3 660.74C421.32 660.74 434.3 673.72 434.3 689.74H472.61V641.91",
    stroke: "#8C8C8C",
    strokeWidth: 0.99,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("text", {
    id: "HSBC Holdings plc",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 16,
    letterSpacing: "0em"
  }, _tspan72 || (_tspan72 = /*#__PURE__*/React.createElement("tspan", {
    x: 402.6,
    y: 629.438
  }, "HSBC Holdings plc")))), /*#__PURE__*/React.createElement("g", {
    id: "Tesla"
  }, _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "BubbleGroup_18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_89",
    opacity: 0.7,
    d: "M1550.51 434.85C1564.04 434.85 1575.01 423.881 1575.01 410.35C1575.01 396.819 1564.04 385.85 1550.51 385.85C1536.98 385.85 1526.01 396.819 1526.01 410.35C1526.01 423.881 1536.98 434.85 1550.51 434.85Z",
    fill: "#FFBBBB",
    stroke: "#333333",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_90",
    d: "M1550.51 416.16C1553.55 416.16 1556.01 413.698 1556.01 410.66C1556.01 407.622 1553.55 405.16 1550.51 405.16C1547.47 405.16 1545.01 407.622 1545.01 410.66C1545.01 413.698 1547.47 416.16 1550.51 416.16Z",
    fill: "#353535"
  }))), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    id: "Line_22",
    d: "M1580.01 410.35C1580.01 426.64 1566.8 439.85 1550.51 439.85V456.64H1607.82",
    stroke: "#8C8C8C",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("text", {
    id: "Tesla_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 16,
    letterSpacing: "0em"
  }, _tspan73 || (_tspan73 = /*#__PURE__*/React.createElement("tspan", {
    x: 1618.44,
    y: 459.988
  }, "Tesla")))), /*#__PURE__*/React.createElement("g", {
    id: "TSMC"
  }, _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "BubbleGroup_19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_91",
    opacity: 0.7,
    d: "M1417.73 403.07C1431.54 403.07 1442.73 391.877 1442.73 378.07C1442.73 364.263 1431.54 353.07 1417.73 353.07C1403.92 353.07 1392.73 364.263 1392.73 378.07C1392.73 391.877 1403.92 403.07 1417.73 403.07Z",
    fill: "#FFBBBB",
    stroke: "#333333",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_92",
    d: "M1417.73 383.88C1420.77 383.88 1423.23 381.418 1423.23 378.38C1423.23 375.342 1420.77 372.88 1417.73 372.88C1414.69 372.88 1412.23 375.342 1412.23 378.38C1412.23 381.418 1414.69 383.88 1417.73 383.88Z",
    fill: "#353535"
  }))), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    id: "Line_23",
    d: "M1417.73 348.07C1434.3 348.07 1447.73 361.5 1447.73 378.07H1494.38V348.07",
    stroke: "#8C8C8C",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("text", {
    id: "TSMC_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 16,
    letterSpacing: "0em"
  }, _tspan74 || (_tspan74 = /*#__PURE__*/React.createElement("tspan", {
    x: 1475.83,
    y: 340.078
  }, "TSMC")))), /*#__PURE__*/React.createElement("g", {
    id: "Eli_Lilly"
  }, _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "BubbleGroup_20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_93",
    opacity: 0.7,
    d: "M498.34 403.57C512.423 403.57 523.84 392.153 523.84 378.07C523.84 363.987 512.423 352.57 498.34 352.57C484.257 352.57 472.84 363.987 472.84 378.07C472.84 392.153 484.257 403.57 498.34 403.57Z",
    fill: "#FFBBBB",
    stroke: "#333333",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_94",
    d: "M498.34 383.89C501.378 383.89 503.84 381.428 503.84 378.39C503.84 375.352 501.378 372.89 498.34 372.89C495.302 372.89 492.84 375.352 492.84 378.39C492.84 381.428 495.302 383.89 498.34 383.89Z",
    fill: "#353535"
  }))), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    id: "Line_24",
    d: "M604.64 316.9V323.85H498.34V347.58C515.18 347.58 528.84 361.24 528.84 378.08",
    stroke: "#8C8C8C",
    strokeWidth: 1.01,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Eli Lilly",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 16,
    letterSpacing: "0em"
  }, _tspan75 || (_tspan75 = /*#__PURE__*/React.createElement("tspan", {
    x: 586.92,
    y: 311.598
  }, "Eli Lilly")))), /*#__PURE__*/React.createElement("g", {
    id: "Berkshire_Hathaway"
  }, _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "BubbleGroup_21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_95",
    opacity: 0.7,
    d: "M189.52 363C203.879 363 215.52 351.359 215.52 337C215.52 322.641 203.879 311 189.52 311C175.161 311 163.52 322.641 163.52 337C163.52 351.359 175.161 363 189.52 363Z",
    fill: "#FFBBBB",
    stroke: "#333333",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_96",
    d: "M189.52 342.83C192.558 342.83 195.02 340.368 195.02 337.33C195.02 334.292 192.558 331.83 189.52 331.83C186.482 331.83 184.02 334.292 184.02 337.33C184.02 340.368 186.482 342.83 189.52 342.83Z",
    fill: "#353535"
  }))), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    id: "Line_25",
    d: "M291.82 268.34V277.48H189.52V306.01C206.64 306.01 220.52 319.89 220.52 337.01",
    stroke: "#8C8C8C",
    strokeWidth: 1.01,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Berkshire Hathaway",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 16,
    letterSpacing: "0em"
  }, _tspan76 || (_tspan76 = /*#__PURE__*/React.createElement("tspan", {
    x: 232.85,
    y: 260.868
  }, "Berkshire Hathaway")))), /*#__PURE__*/React.createElement("g", {
    id: "Meta_Platforms"
  }, _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "BubbleGroup_22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_97",
    opacity: 0.7,
    d: "M1558.8 307.39C1573.44 307.39 1585.3 295.526 1585.3 280.89C1585.3 266.254 1573.44 254.39 1558.8 254.39C1544.16 254.39 1532.3 266.254 1532.3 280.89C1532.3 295.526 1544.16 307.39 1558.8 307.39Z",
    fill: "#FFBBBB",
    stroke: "#333333",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_98",
    d: "M1558.8 286.73C1561.84 286.73 1564.3 284.268 1564.3 281.23C1564.3 278.192 1561.84 275.73 1558.8 275.73C1555.76 275.73 1553.3 278.192 1553.3 281.23C1553.3 284.268 1555.76 286.73 1558.8 286.73Z",
    fill: "#353535"
  }))), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    id: "Line_26",
    d: "M1590.3 280.89C1590.3 298.29 1576.2 312.39 1558.8 312.39V329.91H1650.61V344.02",
    stroke: "#8C8C8C",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("text", {
    id: "Meta Platforms",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 16,
    letterSpacing: "0em"
  }, _tspan77 || (_tspan77 = /*#__PURE__*/React.createElement("tspan", {
    x: 1607.82,
    y: 363.518
  }, "Meta Platforms")))), /*#__PURE__*/React.createElement("g", {
    id: "Nvidia"
  }, _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "BubbleGroup_23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_99",
    opacity: 0.7,
    d: "M1467.53 239.43C1482.44 239.43 1494.53 227.342 1494.53 212.43C1494.53 197.518 1482.44 185.43 1467.53 185.43C1452.62 185.43 1440.53 197.518 1440.53 212.43C1440.53 227.342 1452.62 239.43 1467.53 239.43Z",
    fill: "#FFBBBB",
    stroke: "#333333",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_100",
    d: "M1467.53 218.27C1470.57 218.27 1473.03 215.808 1473.03 212.77C1473.03 209.732 1470.57 207.27 1467.53 207.27C1464.49 207.27 1462.03 209.732 1462.03 212.77C1462.03 215.808 1464.49 218.27 1467.53 218.27Z",
    fill: "#353535"
  }))), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    id: "Line_27",
    d: "M1435.53 212.43C1435.53 230.1 1449.86 244.43 1467.53 244.43V262.43H1436.62V304.18",
    stroke: "#8C8C8C",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("text", {
    id: "Nvidia_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 16,
    letterSpacing: "0em"
  }, _tspan78 || (_tspan78 = /*#__PURE__*/React.createElement("tspan", {
    x: 1411.7,
    y: 319.558
  }, "Nvidia")))), /*#__PURE__*/React.createElement("g", {
    id: "Amazon"
  }, _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "BubbleGroup_24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_101",
    opacity: 0.7,
    d: "M1475.83 239.36C1491.02 239.36 1503.33 227.048 1503.33 211.86C1503.33 196.672 1491.02 184.36 1475.83 184.36C1460.64 184.36 1448.33 196.672 1448.33 211.86C1448.33 227.048 1460.64 239.36 1475.83 239.36Z",
    fill: "#FFBBBB",
    stroke: "#333333",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_102",
    d: "M1475.83 217.7C1478.87 217.7 1481.33 215.238 1481.33 212.2C1481.33 209.162 1478.87 206.7 1475.83 206.7C1472.79 206.7 1470.33 209.162 1470.33 212.2C1470.33 215.238 1472.79 217.7 1475.83 217.7Z",
    fill: "#353535"
  }))), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    id: "Line_28",
    d: "M1508.33 211.86C1508.33 193.91 1493.78 179.36 1475.83 179.36V140.15H1514.83V108.77",
    stroke: "#8C8C8C",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("text", {
    id: "Amazon_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 16,
    letterSpacing: "0em"
  }, _tspan79 || (_tspan79 = /*#__PURE__*/React.createElement("tspan", {
    x: 1485.94,
    y: 101.018
  }, "Amazon")))), /*#__PURE__*/React.createElement("g", {
    id: "Alphabet_Google"
  }, _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "BubbleGroup_25"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_103",
    opacity: 0.7,
    d: "M1650.1 235.02C1665.56 235.02 1678.1 222.484 1678.1 207.02C1678.1 191.556 1665.56 179.02 1650.1 179.02C1634.64 179.02 1622.1 191.556 1622.1 207.02C1622.1 222.484 1634.64 235.02 1650.1 235.02Z",
    fill: "#FFBBBB",
    stroke: "#333333",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_104",
    d: "M1650.1 212.87C1653.14 212.87 1655.6 210.408 1655.6 207.37C1655.6 204.332 1653.14 201.87 1650.1 201.87C1647.06 201.87 1644.6 204.332 1644.6 207.37C1644.6 210.408 1647.06 212.87 1650.1 212.87Z",
    fill: "#353535"
  }))), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    id: "Line_29",
    d: "M1650.1 174.02C1668.33 174.02 1683.1 188.79 1683.1 207.02H1729.55V181.4",
    stroke: "#8C8C8C",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("text", {
    id: "Alphabet (Google)",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 16,
    letterSpacing: "0em"
  }, _tspan80 || (_tspan80 = /*#__PURE__*/React.createElement("tspan", {
    x: 1702.13,
    y: 171.708
  }, "Alphabet (Google)")))), /*#__PURE__*/React.createElement("g", {
    id: "Saudi_Aramco"
  }, _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "BubbleGroup_26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_105",
    opacity: 0.7,
    d: "M972.31 222.62C988.05 222.62 1000.81 209.86 1000.81 194.12C1000.81 178.38 988.05 165.62 972.31 165.62C956.57 165.62 943.81 178.38 943.81 194.12C943.81 209.86 956.57 222.62 972.31 222.62Z",
    fill: "#FFBBBB",
    stroke: "#333333",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_106",
    d: "M972.31 199.97C975.348 199.97 977.81 197.508 977.81 194.47C977.81 191.432 975.348 188.97 972.31 188.97C969.272 188.97 966.81 191.432 966.81 194.47C966.81 197.508 969.272 199.97 972.31 199.97Z",
    fill: "#353535"
  }))), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    id: "Line_30",
    d: "M934.52 305.04V280.88H972.31V227.62C953.81 227.62 938.81 212.62 938.81 194.12",
    stroke: "#8C8C8C",
    strokeWidth: 1.01,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Saudi Aramco",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 16,
    letterSpacing: "0em"
  }, _tspan81 || (_tspan81 = /*#__PURE__*/React.createElement("tspan", {
    x: 885.42,
    y: 320.238
  }, "Saudi Aramco")))), /*#__PURE__*/React.createElement("g", {
    id: "Apple"
  }, _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "BubbleGroup_27"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_107",
    opacity: 0.7,
    d: "M1326.43 159.07C1342.45 159.07 1355.43 146.086 1355.43 130.07C1355.43 114.054 1342.45 101.07 1326.43 101.07C1310.41 101.07 1297.43 114.054 1297.43 130.07C1297.43 146.086 1310.41 159.07 1326.43 159.07Z",
    fill: "#FFBBBB",
    stroke: "#333333",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_108",
    d: "M1326.43 135.94C1329.47 135.94 1331.93 133.478 1331.93 130.44C1331.93 127.402 1329.47 124.94 1326.43 124.94C1323.39 124.94 1320.93 127.402 1320.93 130.44C1320.93 133.478 1323.39 135.94 1326.43 135.94Z",
    fill: "#353535"
  }))), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    id: "Line_31",
    d: "M1360.43 130.07C1360.43 148.85 1345.21 164.07 1326.43 164.07V188.37H1346.99V227.22",
    stroke: "#8C8C8C",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("text", {
    id: "Apple_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 16,
    letterSpacing: "0em"
  }, _tspan82 || (_tspan82 = /*#__PURE__*/React.createElement("tspan", {
    x: 1325.22,
    y: 241.518
  }, "Apple")))), /*#__PURE__*/React.createElement("g", {
    id: "Microsoft"
  }, _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "BubbleGroup_28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_109",
    opacity: 0.7,
    d: "M1318.14 148.36C1334.43 148.36 1347.64 135.152 1347.64 118.86C1347.64 102.568 1334.43 89.36 1318.14 89.36C1301.85 89.36 1288.64 102.568 1288.64 118.86C1288.64 135.152 1301.85 148.36 1318.14 148.36Z",
    fill: "#FFBBBB",
    stroke: "#333333",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_110",
    d: "M1318.14 124.73C1321.18 124.73 1323.64 122.268 1323.64 119.23C1323.64 116.192 1321.18 113.73 1318.14 113.73C1315.1 113.73 1312.64 116.192 1312.64 119.23C1312.64 122.268 1315.1 124.73 1318.14 124.73Z",
    fill: "#353535"
  }))), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    id: "Line_32",
    d: "M1318.14 84.36C1299.09 84.36 1283.64 99.81 1283.64 118.86H1245.88V98.31H1207.48",
    stroke: "#8C8C8C",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("text", {
    id: "Microsoft_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 16,
    letterSpacing: "0em"
  }, _tspan83 || (_tspan83 = /*#__PURE__*/React.createElement("tspan", {
    x: 1137.24,
    y: 101.658
  }, "Microsoft")))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg);
export default __webpack_public_path__ + "static/media/svg.a3f0b2bfa7bfae2188a6b151f5ec229c.svg";
export { ForwardRef as ReactComponent };